import { render, staticRenderFns } from "./SmsIcon.vue?vue&type=template&id=3d7400d0&"
import script from "./SmsIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SmsIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports